import React from 'react';
import { EntitySecurityProvider, SECURITY_ACTIONS, SecuredButton } from '../auth/Security';
import { BUTTON_VARIANTS, SIZES } from '../constants/constants';
import { ENTITY_CONSTANTS } from '../constants/entityConstants';
import I18n from '../i18n/I18n';
import { useSavedFiltersContext } from '../list/savedFilters';
import AppliedSavedFilterControls from './AppliedSavedFilterControls';

export default function SavedFilterControls() {
    const {
        state: { hasActiveFilters, appliedSavedFilter, hasUnsavedChanges, savingFilter },
        actions: { setSaveFilterOpen, clearAppliedSavedFilter, saveAppliedFilterChanges }
    } = useSavedFiltersContext();

    return (
        <>
            {appliedSavedFilter ? (
                <EntitySecurityProvider
                    entityName={ENTITY_CONSTANTS.preference}
                    entitySecurity={appliedSavedFilter.security ?? { allowedActions: [] }}
                >
                    <AppliedSavedFilterControls
                        entityName={ENTITY_CONSTANTS.preference}
                        filterName={appliedSavedFilter.name}
                        hasUnsavedChanges={hasUnsavedChanges}
                        onClear={clearAppliedSavedFilter}
                        onSave={saveAppliedFilterChanges}
                        onSaveAsNew={() => setSaveFilterOpen(true)}
                        savingFilter={savingFilter}
                    />
                </EntitySecurityProvider>
            ) : (
                hasActiveFilters && (
                    <SecuredButton
                        securityAction={SECURITY_ACTIONS.EDIT}
                        size={SIZES.small}
                        variant={BUTTON_VARIANTS.outlined}
                        onClick={() => setSaveFilterOpen(true)}
                    >
                        <I18n token="filter.savedFilter.modal.title" />
                    </SecuredButton>
                )
            )}
        </>
    );
}
